export default __webpack_public_path__ + "static/dashboard-report-data1-3749ddc9bd09925e3855a5f1087f28d1.jpg";